export enum SalesOrderStatus {
    Draft = 0,
    Open=2,
    PartiallyPosted=3,
    Posted = 1,
}